var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 172,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.34 159.983l-2.69 11.127-178.228.474L0 160.317l55.793-20.092 2.44-21.356c-4.026-5.805-6.978-12.059-9.15-18.995-16.456-16.99-13.992-39.143-5.32-39.86-.09-3.543-.132-7.23-.132-11.081C43.631 23.265 60.021 0 91.548 0s47.395 22.503 47.395 52.879c0 2.458-.008 4.832-.026 7.14 9.134-.812 12.444 20.97-2.978 38.329-1.796 8.234-4.642 15.272-9.134 21.831l3.444 20.744 53.091 19.06zm-64.633-9.994c-.308-3.884-.822-12.702-1.176-19.028-4.349 4.16-9.565 8.292-15.847 12.604l-16.948-.25c-6.474-4.258-11.956-8.526-16.596-12.958-.347 6.992-.858 17.312-1.041 21.468-.594 13.445 52.838 13.687 51.608-1.836zm9.804-101.866c0-20.758-16.905-37.135-36.965-37.135-20.06 0-36.967 16.247-36.967 37.135 0 47.895 5.75 65.007 33.603 83.07l9.478.284C124.23 113.4 128.51 95.76 128.51 48.123z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.d350c2dc1857d64839bbd932dffde024.svg";
export { ForwardRef as ReactComponent };